import { Directive, ElementRef, HostListener, Input } from '@angular/core';

enum KeyCodes {
  Dash = 189,
  Subtract = 109,
  Delete = 46,
  Backspace = 8,
  Tab = 9,
  Escape = 27,
  Enter = 13,
  A = 65,
  C = 67,
  V = 86,
  X = 88
}

@Directive({
  selector: '[OnlyNumber]'
})
export class OnlyNumberDirective {
  @Input() OnlyNumber: boolean;
  @Input() OnlyNumberAllowNegative: boolean = false;
  @Input() maxNumber?: number = null;
  @Input() minNumber?: number = null;
  @Input() SpecialCase: any = null;

  constructor(private el: ElementRef) {
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: any) {
    const fistCharAlreadyInserted = this.el.nativeElement.value[0];
    const e = <KeyboardEvent>event;
    if (this.OnlyNumber) {
      if ([KeyCodes.Delete, KeyCodes.Backspace, KeyCodes.Tab, KeyCodes.Escape, KeyCodes.Enter].indexOf(e.keyCode) !== -1 ||
        // Allow: Ctrl+A
        (e.keyCode === KeyCodes.A && (e.ctrlKey || e.metaKey)) ||
        // Allow: Ctrl+C
        (e.keyCode === KeyCodes.C && (e.ctrlKey || e.metaKey)) ||
        // Allow: Ctrl+V
        (e.keyCode === KeyCodes.V && (e.ctrlKey || e.metaKey)) ||
        // Allow: Ctrl+X
        (e.keyCode === KeyCodes.X && (e.ctrlKey || e.metaKey)) ||
        // Allow: home, end, left, right
        (e.keyCode >= 35 && e.keyCode <= 39) ||
        //if configured to accept negative numbers too accept dash (minus sign)
        (this.OnlyNumberAllowNegative && !fistCharAlreadyInserted && (e.keyCode === KeyCodes.Dash || e.keyCode === KeyCodes.Subtract))) {
        // let it happen, don't do anything
        return;
      }
      // Ensure that it is a number and stop the keypress
      if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
        e.preventDefault();
      }

    }
  }

  @HostListener('keyup', ['$event'])
  onKeyUp($event: any) {

    let elementValue: number;
    if (this.el.nativeElement.value !== '') {
      elementValue = parseInt(this.el.nativeElement.value, 10);
      this.setValidValue(elementValue);
    }
  }

  setValidValue(newValue: number) {
    if (this.SpecialCase !== null && this.replaceSpecialCaseNumber(newValue)) {
      return;
    }

    if (this.maxNumber !== null) {

      if (newValue > this.maxNumber) {
        //do not allow this and change the value to the max number
        this.el.nativeElement.value = this.maxNumber;
      }
    }

    if (this.minNumber !== null) {
      if (newValue < this.minNumber) {
        //do not allow this and change the value to the max number
        this.el.nativeElement.value = this.minNumber;
      }
    }
  }

  onPaste($event: any) {
    $event.stopPropagation();
    $event.preventDefault();
    const clipboardData = $event.clipboardData || (<any>window).clipboardData;
    if (clipboardData) {
      const pastedData: string = clipboardData.getData('Text');
      if (pastedData && pastedData !== '') {
        const pastedValue = parseInt(pastedData, 10);
        this.setValidValue(pastedValue);
      }
    }
  }

  replaceSpecialCaseNumber(newValue: number) {
    if (this.SpecialCase !== null && this.SpecialCase.numberPressed !== null) {
      if (newValue === this.SpecialCase.numberPressed && this.SpecialCase.convertToNumber !== null) {
        this.el.nativeElement.value = this.SpecialCase.convertToNumber;
        return true;
      }
    }
    return false;
  }
}
